import React, { Component } from "react";
import Navbar from "./Navbar";
//import ChatSys from "./ChatSys";
import ChatSys2 from "./ChatSys";

class Chat extends Component {

    state = {loggedIn: false, uid: null};

    render() {
        return (
            <div>
                <Navbar/>
                <header className="masthead bg-primary text-white text-center">
                    <div className="container d-flex align-items-center flex-column">
                        <h1 className="masthead-heading text-uppercase mb-0">Live Chat</h1>
                    </div>
                </header>
                <ChatSys2/>
                <section className="page-section portfolio mb-0" id="portfolio">
                <div className="container">
                    <h3 className="page-section-heading text-center text-uppercase text-secondary mb-0">How the chat works:</h3>
                    <br/>
                    <div className="row">
                        


                        <div className="col-lg-12 ms-auto text-center"><p className="lead">Every few seconds, a PHP script will update the webpage with new messages from a MySQL database. I use Google 2FA to allow users to "sign in" and send messages. This works in real-time, so you can try it with two separate browsers.</p></div>

                    </div>
                </div>
            </section>
            </div>
            
        );
    }
}

export default Chat;